import BaseService from './BaseService';

class DashboardService {
  async getSummary() {
    return BaseService.get('/dashboard/summary');
  }

  async getCalculationsAnalytics(period = 'last30days') {
    return BaseService.get('/dashboard/calculations/analytics', { period });
  }

  async getUsersAnalytics() {
    return BaseService.get('/dashboard/users/analytics');
  }

  async getFinancialAnalytics(period = 'last30days') {
    return BaseService.get('/dashboard/financial/analytics', { period });
  }

  async getMaterialsAnalytics() {
    return BaseService.get('/dashboard/materials/analytics');
  }

  async getIdeasAnalytics() {
    return BaseService.get('/dashboard/ideas/analytics');
  }

  async getRealtime() {
    return BaseService.get('/dashboard/realtime');
  }

  async getMobile() {
    return BaseService.get('/dashboard/mobile');
  }
}

export default new DashboardService();

